<template>
  <div id="social-number-form">
    <header class="panel__header mt-2">
      <h2 class="panel__title">Informe os dados do seu cartão social</h2>
    </header>

    <div id="form-dados-pessoais" class="row mt-4">
      <div class="col-12">
        <div class="row">
          <p class="col-md-6 col-sm-12">
            <input
              :class="{
                input: true,
                'is-invalid': errors.has('cadastro_de_cartao_social__numero'),
              }"
              name="cadastro_de_cartao_social__numero"
              v-validate="'required'"
              type="text"
              class="form-control"
              v-model="cadastro_de_cartao_social__numero"
              id="cadastro_de_cartao_social__numero"
              placeholder="Número do cartão social"
              value=""
            />

            <span class="invalid-feedback">
              @{{ errors.first("cadastro_de_cartao_social__numero") }}
            </span>
          </p>

          <p class="col-md-6 col-sm-12">
            <input
              :class="{
                input: true,
                'is-invalid': errors.has('cadastro_de_cartao_social__nome'),
              }"
              name="cadastro_de_cartao_social__nome"
              v-validate="'required'"
              type="text"
              class="form-control"
              v-model="cadastro_de_cartao_social__nome"
              id="cadastro_de_cartao_social__nome"
              placeholder="Nome do Beneficiário"
              value=""
            />

            <span class="invalid-feedback">
              @{{ errors.first("cadastro_de_cartao_social__nome") }}
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  methods: {
    async submit() {
      try {
        if (! await this.$validator.validateAll()) {
          throw new Error('Validação de cadastro social falhou')
        }
        return true;
      } catch (error) {
        $("html, body").animate({scrollTop:$("#cadastroSocio").offset().top - 10}, 500, 'swing');
        return false;
      }
    }
  }
})
</script>